export enum WebsocketCategory {
  Scene = 'scene',
}
